import { render, staticRenderFns } from "./SuccessfulBeneficiaries.vue?vue&type=template&id=70312890&"
import script from "./SuccessfulBeneficiaries.vue?vue&type=script&lang=js&"
export * from "./SuccessfulBeneficiaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports